import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import BrandIdentity from "./common/BrandIdentity";
import ThemeToggle from "./common/ThemeToggle";
import "./LoginPage.css";

const PASSWORD_HINT =
  "8 أحرف على الأقل، حرف كبير، حرف صغير، رقم، ورمز خاص";

function ChangePasswordPage() {
  const navigate = useNavigate();
  const { user, changePassword, logout } = useAuth();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit() {
    setError("");
    setLoading(true);

    try {
      const result = await changePassword(
        currentPassword.trim(),
        newPassword.trim(),
        confirmPassword.trim(),
      );

      if (!result.success) {
        setError(result.error);
        return;
      }

      navigate("/", { replace: true });
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-wrapper">
      <ThemeToggle variant="icon" className="ess-theme-toggle--floating" />
      <div className="login-card">
        <BrandIdentity
          showName={false}
          logoClassName="login-logo-img"
          fallbackClassName="login-logo"
        />
        <p className="login-title">تغيير كلمة المرور</p>
        <p className="login-subtitle">
          مرحباً {user?.name} — يجب تغيير كلمة المرور قبل المتابعة. أدخل كلمة
          المرور الحالية (اللي استلمتها من IT) ثم اختر كلمة مرور جديدة.
        </p>

        <div className="login-field">
          <label className="login-label">كلمة المرور الحالية</label>
          <input
            type="password"
            className="login-input"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            placeholder="أدخل كلمة المرور الحالية"
            autoComplete="current-password"
          />
        </div>

        <div className="login-field">
          <label className="login-label">كلمة المرور الجديدة</label>
          <input
            type="password"
            className="login-input"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder={PASSWORD_HINT}
            autoComplete="new-password"
          />
        </div>

        <div className="login-field" style={{ marginBottom: "8px" }}>
          <label className="login-label">تأكيد كلمة المرور</label>
          <input
            type="password"
            className="login-input"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="أعد كتابة كلمة المرور"
            autoComplete="new-password"
            onKeyDown={(e) => e.key === "Enter" && !loading && handleSubmit()}
          />
        </div>

        {error && <p className="login-error">{error}</p>}

        <div
          className={`login-button ${loading ? "is-loading" : ""}`}
          onClick={!loading ? handleSubmit : undefined}
        >
          {loading ? "جاري الحفظ..." : "حفظ كلمة المرور"}
        </div>

        <p
          className="login-demo-account"
          style={{ marginTop: "16px", cursor: "pointer" }}
          onClick={logout}
        >
          تسجيل الخروج
        </p>
      </div>
    </div>
  );
}

export default ChangePasswordPage;
